export function getFirstLetter(name) {
    if (name && typeof name === 'string') {
        return name.charAt(0).toLocaleUpperCase();
    }
    return '';
}
